import { Menu } from '../../api/menu/menu.types';
import { Async } from '../../types/data.types';
import {
  NutritionInfoDataDictionary,
  SetMenu,
  SetNutritionInfo,
} from './menu.types';

export const setMenu = (menu: Async<Menu>, menuUrl: string): SetMenu => ({
  type: 'SET_MENU',
  payload: { menu, menuUrl },
});

export const setNutritionInfo = (
  nutritionInfo: Async<NutritionInfoDataDictionary>,
  nutritionInfoUrl: string,
): SetNutritionInfo => ({
  type: 'SET_NUTRITION_INFO',
  payload: { nutritionInfo, nutritionInfoUrl },
});
